<template>
  <div>
    <app-header bgcolor="#00B25A" :transparent="true" :title="title" back-type="back-app" :needRight="true">
      <div class="header_icon_box" @click="iconClick" name="right">明细说明</div>
    </app-header>
    <div class="container">
      <Integral ref="integral" :info="userCreditAccount" />
      <div class="content">
        <div class="list-wrapper" ref="wrapper">
          <div class="flexbox menu_box">
            <div
              v-for="(item, i) in menu"
              :class="i === currIdx ? 'menuActive' : ''"
              :key="i"
              @click="changeMenuList(i)"
              class="menu_box_item"
            >
              <div class="height_box" v-if="i === currIdx"></div>
              {{ item.name }}
            </div>
          </div>
          <Swipe ref="swipe" duration="250" :show-indicators="false" :loop="false" @change="swipeChanged">
            <!--      要设置父组件的高度,和 overflow 属性,不然 loadBottom 事件无法触发-->
            <SwipeItem
              v-for="(loaded, idx) in allLoaded"
              :key="idx"
              :id="idx"
              class="swipe-item"
              :style="{ height: wrapperHeight + 'px' }"
            >
              <div>
                <mt-loadmore
                  ref="loadmore"
                  :auto-fill="false"
                  :top-method="loadTop"
                  :bottom-method="loadBottom"
                  :bottom-all-loaded="loaded"
                  :topDistance="50"
                  :bottomDistance="50"
                  @top-status-change="handleTopChange"
                  @bottom-status-change="handleBottomChange"
                >
                  <ul>
                    <!--列表-->
                    <li class="list-item" :key="idx + 1" v-for="(item, idx) in list[currIdx]">
                      <logItem :item="item"></logItem>
                    </li>
                  </ul>
                  <div v-if="list[idx].length === 0 && !netFailed[idx]" class="empty_box">
                    <van-empty
                      class="custom-image"
                      image="https://img-ylsn-test.ylyk.com/server/image/course/2025_10_22_1761115604173.png"
                      description="暂无明细"
                    />
                  </div>
                  <div slot="top" class="mint-loadmore-top">
                    <span
                      v-show="topStatus !== 'loading'"
                      :class="{
                        'is-rotate': topStatus === 'drop',
                        arrow: true
                      }"
                    >
                      ↓
                    </span>
                    <span v-show="topStatus === 'pull'">下拉刷新</span>
                    <span v-show="topStatus === 'drop'">松开立即刷新</span>

                    <img
                      v-show="topStatus === 'loading'"
                      src="../../../images/integral/refresh_ing.png"
                      class="circle"
                    />
                    <span v-show="topStatus === 'loading'">刷新中</span>
                  </div>
                  <div slot="bottom" class="mint-loadmore-bottom">
                    <div v-if="!loaded">
                      <span
                        v-show="bottomStatus !== 'loading'"
                        :class="{
                          'is-rotate': bottomStatus === 'drop',
                          arrow: true
                        }"
                      >
                        ↑
                      </span>
                      <span v-show="bottomStatus === 'pull'">上拉刷新</span>
                      <span v-show="bottomStatus === 'drop'">松开立即刷新</span>

                      <img
                        v-show="bottomStatus === 'loading'"
                        src="../../../images/integral/refresh_ing.png"
                        class="circle"
                      />
                      <span v-show="bottomStatus === 'loading'">刷新中</span>
                    </div>
                  </div>
                </mt-loadmore>
                <div v-if="netFailed[idx]" class="retry">
                  <img src="https://img-ylsn-test.ylyk.com/server/image/course/2025_10_22_1761115604173.png" alt="" />
                  <p>网络不给力，请点击重试</p>
                  <div @click="retry">点击重试</div>
                </div>
              </div>
            </SwipeItem>
          </Swipe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant'
import 'vant/lib/swipe/style'
import 'vant/lib/swipe-item/style'
import logItem from './logItem.vue'
// import RankUnavailable from './rank-unavailable'
import { $settingBounces, $gotoProfile } from '@/utils/common/native-api'
import { integralService } from '@/api'
import Integral from './Integral'
import { integralName } from '@/pages/config'
export default {
  components: {
    Swipe,
    SwipeItem,
    logItem,
    Integral
  },
  data() {
    return {
      title: '积分明细',
      integralName,
      userCreditAccount: {},
      // status：1-已入账，0-待入账，4-已抵扣，3-已取消,5已退回
      menu: [
        { name: '已入账', type: 1 },
        { name: '待入账', type: 0 },
        { name: '已抵扣', type: 4 },
        // { name: '已过期', type: 2 },
        { name: '已退回', type: 5 },
        { name: '已取消', type: 3 }
      ],
      //
      currIdx: 0,
      list: [[], [], [], [], []],
      topStatus: '',
      bottomStatus: '',
      wrapperHeight: 0,
      allLoaded: [false, false, false, false, false],
      netFailed: [false, false, false, false, false],
      loadings: [false, false, false, false, false],
      pageSize: 20,
      popupVisible: false
    }
  },
  created() {
    $settingBounces({
      bounces: 'disenable'
    })
    this.getData(0, 1)
  },
  mounted() {
    // 重写方法,更新 appuser 信息
    // window.loginDidChanged = () => {
    //   appUser.getNativeUser()
    //   this.loadTop()
    // }
    this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 58
    window.addEventListener(
      'onorientationchange' in window ? 'orientationchange' : 'resize',
      this.handleOrientation,
      false
    )
  },
  destroyed() {
    window.removeEventListener(
      'onorientationchange' in window ? 'orientationchange' : 'resize',
      this.handleOrientation,
      false
    )
  },
  methods: {
    // 规则
    iconClick() {
      this.$refs.integral.popupVisible = true
    },
    // complete函数,回传接口成功与失败
    getData(idx, page, complete = undefined, isRefresh = false) {
      const status = this.menu[idx].type
      integralService
        .acountDetail({ status, currentPage: page, pageSize: this.pageSize })
        .then(res => {
          // res.pageData.list = []
          this.userCreditAccount = res.userCreditAccount || {}
          const { list, total } = res.pageData
          if (isRefresh) {
            // 清空数组竟然这么清...
            this.list[idx].length = 0
          }
          this.netFailed[idx] = false
          this.list[idx].push(...list)
          complete && complete(true)
          // 先清除高度样式
          this.$refs.loadmore[idx].$el.style.height = ''
          if (total === this.list[idx].length) {
            this.allLoaded[idx] = true
            // 不满一屏的时候,修改容器高度,
            const height = (total + 1) * 70 + 36
            if (height < this.wrapperHeight) {
              this.$refs.loadmore[idx].$el.style.height = `${this.wrapperHeight}px`
            }
          }
        })
        .catch(err => {
          complete && complete(false)
          // 未登录的情况下, 有旧数据也不展示
          if (this.list[idx].length === 0 || err.code === 10001) {
            // vue数据驱动的本质是监听对象的改动方法,也就是在所有对象上有个Object.defineProperty()方法，通过监听set，get方法去实现
            // 直接更改数组元素,没有这两个方法, 并不能触发页面刷新,，所以就不会更新view；解决方案就是，需要我们主动通知vue；
            // 但是有些方法能够被监听到,push, pop, shift, unshift, splice等等,都是元素个数发生改动的情况,
            // this.netFailed[idx] = true
            this.netFailed.splice(idx, 1, true)
            this.list[idx].length = 0
          }
        })
    },
    onItemClick(userInfo) {
      $gotoProfile(userInfo)
    },
    // 刷新,即加载第一页
    loadTop() {
      // idx 要保留下来,因为网络慢未返回的情况下, 用户切换了tab 导致currIdx值变化,这时候接口完成的回调里,使用 currIdx是错误的
      const idx = this.currIdx
      this.getData(
        idx,
        1,
        state => {
          if (state) {
            // 如果刷新成功的话, 重置当前状态,否则保留现有数据
            this.allLoaded[idx] = false
          }
          this.$refs.loadmore[idx].onTopLoaded()
        },
        true
      )
    },
    loadBottom() {
      const idx = this.currIdx
      if (this.loadings[idx] === true) {
        return
      }
      this.loadings[idx] = true
      const list = this.list[idx]
      const page = Math.floor(list.length / this.pageSize) + 1
      this.getData(idx, page, state => {
        this.loadings[idx] = false
        this.$refs.loadmore[idx].onBottomLoaded() // 固定方法，查询完要调用一次，用于重新定位
      })
    },
    retry() {
      this.getData(this.currIdx, 1, state => {})
    },
    swipeChanged(idx) {
      this.currIdx = idx
      if (this.list[idx].length === 0 && !this.netFailed[idx]) {
        this.getData(idx, 1)
      }
    },
    changeMenuList(idx) {
      if (this.currIdx === idx) return
      this.$refs.swipe.swipeTo(idx)
    },
    handleTopChange(status) {
      this.topStatus = status
    },
    handleBottomChange(status) {
      this.bottomStatus = status
    },
    handleOrientation() {
      let height = 0
      // clientWidth 在屏幕切换后, 读到的值可能还是切换前的值
      const { clientWidth, clientHeight } = document.documentElement
      if (window.orientation === 180 || window.orientation === 0) {
        // 竖屏
        height = Math.max(clientWidth, clientHeight)
      }
      if (window.orientation === 90 || window.orientation === -90) {
        // 横屏
        height = Math.min(clientWidth, clientHeight)
      }
      this.wrapperHeight = height - this.$refs.wrapper.getBoundingClientRect().top - 58
    }
  }
}
</script>
<style lang="less" scoped>
.empty_box {
  padding-top: 10vh;
  /deep/.custom-image .van-empty__image {
    width: 196px;
    height: 166px;
  }
}
</style>
<style lang="scss" scoped>
.container {
  height: 100%;
  background-color: #fff;
  .content {
    background-color: #fff;
    border-radius: 0.16rem;
  }
  .menu_box {
    border-bottom: 1px solid #f2f2f2;
    overflow-x: scroll;
    &::-webkit-scrollbar {
      display: none;
      background-color: transparent;
    }
    .menu_box_item {
      flex-shrink: 0;
      height: 0.8rem;
      line-height: 0.8rem;
      padding: 0 0.24rem;
      font-size: 0.28rem;
      font-weight: 400;
      color: #333333;
      position: relative;
      flex: 1;
      text-align: center;
    }
    .menuActive {
      color: #00b25a;
      font-weight: 600;
    }
    .height_box {
      position: absolute;
      bottom: 0.08rem;
      left: 50%;
      transform: translateX(-50%);
      width: 0.32rem;
      height: 0.08rem;
      background: #00b25a;
      border-radius: 0 0 0.08rem 0.08rem;
    }
  }
  .list-wrapper {
    position: relative;

    // top: 68px;
    -webkit-overflow-scrolling: touch; // 解决view滑动速度慢或者卡顿问题
    .swipe-item {
      overflow: scroll; // 很重要,
      position: relative;
      .huangguan {
        height: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 162px;
        }
      }
      .mint-loadmore-top,
      .mint-loadmore-bottom {
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          color: #999999;
          font-size: 12px;
        }

        .arrow {
          display: inline-block;
          transition: 0.25s linear;
          margin-right: 12px;
        }

        .is-rotate {
          transform: rotate(180deg);
        }

        .circle {
          width: 18px;
          margin-right: 12px;
          animation: loading 0.8s linear infinite;
        }

        @keyframes loading {
          /*以百分比来规定改变发生的时间 也可以通过"from"和"to",等价于0% 和 100%*/
          0% {
            /*rotate(2D旋转) scale(放大或者缩小) translate(移动) skew(翻转)*/
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      }
    }
  }
  .retry {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    //top: 68px;
    img {
      display: block;
      margin: 64px auto 8px;
      width: 200px;
    }
    p {
      text-align: center;
      font-size: 12px;
      color: #666666;
    }
    div {
      font-size: 16px;
      margin: 50px auto;
      padding: 0 65px;
      width: 195px;
      height: 44px;
      text-align: center;
      //vertical-align: center;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.list-item {
  margin: 0 0.32rem;
}
</style>
